import React from 'react'
import { useTranslation } from 'react-i18next'
import { Collapse } from 'antd'
import { sortResponseKeys } from '../FormHelpers'
import Questions from './index'
import QuestionList from './QuestionList'

interface IProps {
  names: string[]
  responses: any
  corrections?: any
}

const Collapsed = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { names, responses, corrections } = props
  const { Panel } = Collapse

  return (
    <Collapse key={`collapse-parent-${names.join('-')}`} accordion>
      <Panel
        key={`collapse-${names.join('-')}`}
        header={t(`form.group.${names.at(-1)}`)}
      >
        <QuestionList
          names={names}
          responses={responses}
          corrections={corrections}
        />
      </Panel>
    </Collapse>
  )
}

export default Collapsed
